import angular from 'angular';

import TermsListComponent from './terms-list-component';

export default angular
  .module('terms-list', [])
  .component('termsList', TermsListComponent);



// WEBPACK FOOTER //
// ./src/modules/terms-preview/components/terms-list/terms-list-module.js